export const SITE_KEY = ""; //configure secret manager once added in Dev , QA & Prod
export const CAPTCHA_CONFIG = false;  // configure secret manager once added in Dev , QA & Prod